import AutomaticMessageForm from './AutomaticMessageForm.component';

export default AutomaticMessageForm;
